/**
 * 根据通知类型构建管理端跳转路由
 * @param {{ type: string, ref_id: number, payload?: object }} item
 * @returns {{ name: string, query: Record<string, string|number> }}
 */
export function buildNotificationRoute(item) {
  const payload = item.payload || {}
  switch (item.type) {
    case 'unit_member':
      return { name: 'member-namage', query: { tab: 'name1', id: item.ref_id } }
    case 'personal_member':
      return { name: 'member-namage', query: { tab: 'name2', id: item.ref_id } }
    case 'committee_member':
      return { name: 'member-namage', query: { tab: 'name3', id: item.ref_id } }
    case 'activity_registration':
      return {
        name: 'activity-signup-list',
        query: { act_id: payload.activities_id, id: item.ref_id },
      }
    case 'competition_registration':
      return {
        name: 'competition-signup-list',
        query: { com_id: payload.competitions_id, id: item.ref_id },
      }
    default:
      return { name: 'home', query: {} }
  }
}
